import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { useNavigate, useParams } from "react-router-dom";

interface Product {
  name: string;
  manufacturer: string;
  date: string;
  description: string;
  category: string;
}

const Products = () => {
  const { status } = useParams();
  const navigate = useNavigate();
  
  // Example data remains the same
  const newProducts: Product[] = [
    {
      name: "MediCure Plus",
      manufacturer: "PharmaCorp",
      date: "2024-03-15",
      description: "New generation antibiotic with reduced side effects",
      category: "Antibiotics"
    },
    {
      name: "VitaBoost",
      manufacturer: "HealthLife",
      date: "2024-03-10",
      description: "Advanced multivitamin supplement",
      category: "Supplements"
    }
  ];

  const bannedProducts: Product[] = [
    {
      name: "PainAway",
      manufacturer: "MedPharm",
      date: "2024-02-28",
      description: "Recalled due to adverse effects",
      category: "Pain Management"
    },
    {
      name: "SleepEase",
      manufacturer: "DreamPharma",
      date: "2024-02-15",
      description: "Banned due to undisclosed ingredients",
      category: "Sleep Aid"
    }
  ];

  const products = status === "banned" ? bannedProducts : newProducts;
  const isNewProducts = status !== "banned";

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-4xl font-bold">Medical Products</h1>
        <div className="space-x-4">
          <Button
            variant={isNewProducts ? "default" : "outline"}
            onClick={() => navigate("/products/new")}
          >
            New Products
          </Button>
          <Button
            variant={!isNewProducts ? "default" : "outline"}
            onClick={() => navigate("/products/banned")}
          >
            Banned Products
          </Button>
        </div>
      </div>

      <Table>
        <TableCaption>
          {isNewProducts
            ? "List of newly approved medical products"
            : "List of banned or recalled medical products"}
        </TableCaption>
        <TableHeader>
          <TableRow>
            <TableHead>Product Name</TableHead>
            <TableHead>Manufacturer</TableHead>
            <TableHead>Category</TableHead>
            <TableHead>{isNewProducts ? "Description" : "Reason for Ban"}</TableHead>
            <TableHead>{isNewProducts ? "Approval Date" : "Ban Date"}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {products.map((product, index) => (
            <TableRow key={`${product.name}-${index}`}>
              <TableCell className="font-medium">{product.name}</TableCell>
              <TableCell>{product.manufacturer}</TableCell>
              <TableCell>
                <Badge variant={isNewProducts ? "secondary" : "destructive"}>
                  {product.category}
                </Badge>
              </TableCell>
              <TableCell>{product.description}</TableCell>
              <TableCell>{new Date(product.date).toLocaleDateString()}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default Products; 